app.service('deliveryPointAutocomplete', function(console, deliveryPointLocation) {

	function setAutocomplete(autocompleteInput, setLocation, showEmptySearch) {
		const options = {
			componentRestrictions: { country: "pl" },
		};
		const autocomplete = new google.maps.places.Autocomplete(autocompleteInput, options);
		google.maps.event.addListener(autocomplete, 'place_changed', function () {
			const { geometry } = autocomplete.getPlace();
			if (!geometry || !geometry.location) {
				deliveryPointLocation.findPlaceByAddress($(autocompleteInput).val(), function(location, partialMatch){
					if (location && !partialMatch) {
						setLocation(location);
					} else {
						showEmptySearch();
					}
				});
			} else {
				const { location } = geometry;
				setLocation(location);
			}
		});
		$(autocompleteInput).keydown(function (event) {
			if (event.which == 13) {
				event.preventDefault();
			}
		});
	}

	return {
		setAutocomplete
	};
});